import React from 'react';
import parametricPredictionIcon from '../assets/parametric-prediction-and-design.png';
import chatbotIcon from '../assets/chatbot.png';
import geometryPreparationIcon from '../assets/geometry-preparation.png';
import meshHelperIcon from '../assets/mesh-helper.png';
import simulationModelSetupIcon from '../assets/simulation-model-setup.png';
import postProcessingIcon from '../assets/post-processing.png';

export type AIOption =
  | 'parametric-prediction'
  | 'chatbot'
  | 'geometry-prep'
  | 'mesh-helper'
  | 'simulation-setup'
  | 'post-processing';

interface AIOptionData {
  id: AIOption;
  icon: string;
  title: string;
  description: string;
  available: boolean;
}

interface AIOptionSelectionProps {
  onOptionSelect: (option: AIOption) => void;
}

export const AIOptionSelection: React.FC<AIOptionSelectionProps> = ({ onOptionSelect }) => {
  const aiOptions: AIOptionData[] = [
    {
      id: 'parametric-prediction',
      icon: parametricPredictionIcon,
      title: 'Parametric Prediction and Design',
      description: 'Recommend optimal input parameters for faster CFD setup.',
      available: true,
    },
    {
      id: 'chatbot',
      icon: chatbotIcon,
      title: 'Chatbot',
      description: 'Answers questions and guides workflows with AI assistance.',
      available: false,
    },
    {
      id: 'geometry-prep',
      icon: geometryPreparationIcon,
      title: 'Geometry Preparation',
      description: 'Cleans and simplifies CAD geometry automatically for simulation.',
      available: false,
    },
    {
      id: 'mesh-helper',
      icon: meshHelperIcon,
      title: 'Mesh Helper',
      description: 'Suggests and refines mesh settings using machine learning.',
      available: false,
    },
    {
      id: 'simulation-setup',
      icon: simulationModelSetupIcon,
      title: 'Simulation Model Setup',
      description: 'Pre-configures physics and boundary settings with AI predictions.',
      available: false,
    },
    {
      id: 'post-processing',
      icon: postProcessingIcon,
      title: 'Post-processing',
      description: 'Highlights key results and auto-generates insights from simulations.',
      available: false,
    },
  ];

  const handleOptionClick = (option: AIOptionData) => {
    if (option.available) {
      onOptionSelect(option.id);
    }
  };

  return (
    <div className="wizard-step-container ai-option-selection">
      <h2>Welcome to Simerics AI</h2>
      <p className="subtitle">Choose an AI option to start.</p>

      <div className="option-card active-option">
        <div
          className="option-card-content"
          onClick={() => handleOptionClick(aiOptions[0])}
        >
          <div className="option-icon">
            <img src={aiOptions[0].icon} alt={aiOptions[0].title} />
          </div>
          <div className="option-text">
            <h3>{aiOptions[0].title}</h3>
            <p>{aiOptions[0].description}</p>
          </div>
        </div>
      </div>

      <h3 className="coming-soon-header">Coming Soon</h3>

      <div className="coming-soon-options">
        {aiOptions.slice(1).map((option) => (
          <div key={option.id} className="option-card coming-soon">
            <div className="option-card-content">
              <div className="option-icon">
                <img src={option.icon} alt={option.title} />
              </div>
              <div className="option-text">
                <h3>{option.title}</h3>
                <p>{option.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

